import React, { useEffect } from "react";
import FeatherIcon from "feather-icons-react";
import Button from "./button";

const KvkDetailsModal = ({ isOpen, onClose, kvkDetails }) => {
  useEffect(() => {
    const modal = document.getElementById("kvk-details-modal");
    if (isOpen) {
      modal.showModal();
    } else if (modal.open) {
      modal.close();
    }
  }, [isOpen]);

  const handleClose = () => {
    onClose();
  };

  const handleESC = (event) => {
    event.preventDefault();
    handleClose();
  }

  return (
    <dialog id="kvk-details-modal" className="modal backdrop:bg-[#091E428A]" onCancel={handleESC}>
      <div className="relative col-start-1 row-start-1 max-h-[calc(100vh-5em)] w-11/12 max-w-5xl overflow-y-auto rounded-md bg-white text-ink shadow-overlay">
        <div className="modal-content">
          <button
            type="button"
            aria-label="Sluiten"
            className="absolute right-4 top-4 flex h-8 w-8 items-center justify-center rounded text-ink-subtlest hover:bg-[#091E420F]"
            onClick={handleClose}
          >
            <FeatherIcon icon="x" size={16} />
          </button>
          <h1 className="modal-title px-6 pt-6 text-xl font-medium text-ink">
            KVK Details
          </h1>
          {(
            kvkDetails && (
              <div className="max-h-96 overflow-y-auto px-6 py-4 text-sm text-ink">
                <div className="grid grid-cols-1 gap-x-8 gap-y-3 md:grid-cols-2">
                  <div>
                    <label className="font-medium text-ink-subtlest">KVK Number: </label>
                    <span>{kvkDetails?.kvkNummer}</span>
                  </div>
                  <div>
                    <label className="font-medium text-ink-subtlest">Non-Mailing Indicator: </label>
                    <span>{kvkDetails?.indNonMailing}</span>
                  </div>
                  <div>
                    <label className="font-medium text-ink-subtlest">Company Name: </label>
                    <span>{kvkDetails?.naam}</span>
                  </div>
                  <div>
                    <label className="font-medium text-ink-subtlest">Formal Registration Date: </label>
                    <span>{kvkDetails?.formeleRegistratiedatum}</span>
                  </div>
                  <div>
                    <label className="font-medium text-ink-subtlest">Start Date: </label>
                    <span>{kvkDetails?.materieleRegistratie?.datumAanvang}</span>
                  </div>
                  <div>
                    <label className="font-medium text-ink-subtlest">Total Working Persons: </label>
                    <span>{kvkDetails?.totaalWerkzamePersonen}</span>
                  </div>
                  <div>
                    <label className="font-medium text-ink-subtlest">Statutory Name: </label>
                    <span>{kvkDetails?.statutaireNaam}</span>
                  </div>
                  {kvkDetails?.handelsnamen?.map((handelsnaam, index) => (
                    <div key={index}>
                      <label className="font-medium text-ink-subtlest">Trade Name {index + 1}: </label>
                      <span>{handelsnaam?.naam}</span>
                    </div>
                  ))}
                  {kvkDetails?.sbiActiviteiten?.map((activiteit, index) => (
                    <div key={index}>
                      <label className="font-medium text-ink-subtlest">SBI Code {index + 1}: </label>
                      <span>{activiteit?.sbiCode} - {activiteit?.sbiOmschrijving} - {activiteit?.indHoofdactiviteit}</span>
                    </div>
                  ))}
                  <div>
                    <label className="font-medium text-ink-subtlest">Self Link: </label>
                    <a href={kvkDetails?._links?.self?.href} className="break-all text-brand hover:underline" target="_blank" rel="noopener noreferrer">{kvkDetails?._links?.self?.href}</a>
                  </div>
                  <div>
                    <label className="font-medium text-ink-subtlest">Establishments Link: </label>
                    <a href={kvkDetails?._links?.vestigingen?.href} className="break-all text-brand hover:underline" target="_blank" rel="noopener noreferrer">{kvkDetails?._links?.vestigingen?.href}</a>
                  </div>
                  <div className="md:col-span-2">
                    <h2 className="mb-2 mt-4 border-t border-line pt-4 text-base font-semibold text-ink">Head Office Details</h2>
                    <div>
                      <label className="font-medium text-ink-subtlest">Branch Number: </label>
                      <span>{kvkDetails?._embedded?.hoofdvestiging?.vestigingsnummer}</span>
                    </div>
                    <div>
                      <label className="font-medium text-ink-subtlest">KVK Number: </label>
                      <span>{kvkDetails?._embedded?.hoofdvestiging?.kvkNummer}</span>
                    </div>
                    <div>
                      <label className="font-medium text-ink-subtlest">Formal Registration Date: </label>
                      <span>{kvkDetails?._embedded?.hoofdvestiging?.formeleRegistratiedatum}</span>
                    </div>
                    <div>
                      <label className="font-medium text-ink-subtlest">Start Date: </label>
                      <span>{kvkDetails?._embedded?.hoofdvestiging?.materieleRegistratie?.datumAanvang}</span>
                    </div>
                    <div>
                      <label className="font-medium text-ink-subtlest">First Trade Name: </label>
                      <span>{kvkDetails?._embedded?.hoofdvestiging?.eersteHandelsnaam}</span>
                    </div>
                    <div>
                      <label className="font-medium text-ink-subtlest">Main Office: </label>
                      <span>{kvkDetails?._embedded?.hoofdvestiging?.indHoofdvestiging}</span>
                    </div>
                    <div>
                      <label className="font-medium text-ink-subtlest">Commercial Establishment: </label>
                      <span>{kvkDetails?._embedded?.hoofdvestiging?.indCommercieleVestiging}</span>
                    </div>
                    <div>
                      <label className="font-medium text-ink-subtlest">Total Working Persons: </label>
                      <span>{kvkDetails?._embedded?.hoofdvestiging?.totaalWerkzamePersonen}</span>
                    </div>
                    {kvkDetails?._embedded?.hoofdvestiging?.adressen?.map((address, index) => (
                      <div key={index}>
                        <label className="font-medium text-ink-subtlest">Address {index + 1}: </label>
                        <span>{address?.volledigAdres}</span>
                        <div className="ml-4">
                          <label className="font-medium text-ink-subtlest">Street Name: </label>
                          <span>{address?.straatnaam}</span>
                        </div>
                        <div className="ml-4">
                          <label className="font-medium text-ink-subtlest">House Number: </label>
                          <span>{address?.huisnummer}{address?.huisletter}</span>
                        </div>
                        <div className="ml-4">
                          <label className="font-medium text-ink-subtlest">Postal Code: </label>
                          <span>{address?.postcode}</span>
                        </div>
                        <div className="ml-4">
                          <label className="font-medium text-ink-subtlest">City: </label>
                          <span>{address?.plaats}</span>
                        </div>
                        <div className="ml-4">
                          <label className="font-medium text-ink-subtlest">Country: </label>
                          <span>{address?.land}</span>
                        </div>
                      </div>
                    ))}
                    <div>
                      <label className="font-medium text-ink-subtlest">Head Office Self Link: </label>
                      <a href={kvkDetails?._embedded?.hoofdvestiging?._links?.self?.href} className="break-all text-brand hover:underline" target="_blank" rel="noopener noreferrer">{kvkDetails?._embedded?.hoofdvestiging?._links?.self?.href}</a>
                    </div>
                    <div>
                      <label className="font-medium text-ink-subtlest">Head Office Establishments Link: </label>
                      <a href={kvkDetails?._embedded?.hoofdvestiging?._links?.vestigingen?.href} className="break-all text-brand hover:underline" target="_blank" rel="noopener noreferrer">{kvkDetails?._embedded?.hoofdvestiging?._links?.vestigingen?.href}</a>
                    </div>
                    <div>
                      <label className="font-medium text-ink-subtlest">Head Office Basic Profile Link: </label>
                      <a href={kvkDetails?._embedded?.hoofdvestiging?._links?.basisprofiel?.href} className="break-all text-brand hover:underline" target="_blank" rel="noopener noreferrer">{kvkDetails?._embedded?.hoofdvestiging?._links?.basisprofiel?.href}</a>
                    </div>
                    <div>
                      <label className="font-medium text-ink-subtlest">Head Office Establishment Profile Link: </label>
                      <a href={kvkDetails?._embedded?.hoofdvestiging?._links?.vestigingsprofiel?.href} className="break-all text-brand hover:underline" target="_blank" rel="noopener noreferrer">{kvkDetails?._embedded?.hoofdvestiging?._links?.vestigingsprofiel?.href}</a>
                    </div>
                  </div>
                  <div className="md:col-span-2">
                    <h2 className="mb-2 mt-4 border-t border-line pt-4 text-base font-semibold text-ink">Owner Details</h2>
                    <div>
                      <label className="font-medium text-ink-subtlest">RSIN: </label>
                      <span>{kvkDetails?._embedded?.eigenaar?.rsin}</span>
                    </div>
                    <div>
                      <label className="font-medium text-ink-subtlest">Legal Form: </label>
                      <span>{kvkDetails?._embedded?.eigenaar?.rechtsvorm}</span>
                    </div>
                    <div>
                      <label className="font-medium text-ink-subtlest">Extended Legal Form: </label>
                      <span>{kvkDetails?._embedded?.eigenaar?.uitgebreideRechtsvorm}</span>
                    </div>
                    <div>
                      <label className="font-medium text-ink-subtlest">Owner Self Link: </label>
                      <a href={kvkDetails?._embedded?.eigenaar?._links?.self?.href} className="break-all text-brand hover:underline" target="_blank" rel="noopener noreferrer">{kvkDetails?._embedded?.eigenaar?._links?.self?.href}</a>
                    </div>
                    <div>
                      <label className="font-medium text-ink-subtlest">Owner Basic Profile Link: </label>
                      <a href={kvkDetails?._embedded?.eigenaar?._links?.basisprofiel?.href} className="break-all text-brand hover:underline" target="_blank" rel="noopener noreferrer">{kvkDetails?._embedded?.eigenaar?._links?.basisprofiel?.href}</a>
                    </div>
                  </div>
                </div>
              </div>
            )
          )}
          <div className="flex justify-end gap-2 px-6 pb-6 pt-2">
            <Button btnClassNames="h-8 rounded bg-[#091E420F] px-3 text-sm font-medium text-ink hover:bg-[#091E4224]" text="Close" onClick={handleClose} />
          </div>
        </div>
      </div>
    </dialog>
  );
};

export default KvkDetailsModal;
